<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Pedidos dos Credores</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Pedidos dos Credores',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">
                        <v-tooltip bottom>
                            <template #activator="{ on }">
                                <v-btn v-if="$check(user, ['creditorsrequests.create'])" v-on="on" id="btnNew" type="button" color="primary" elevation="0"
                                    to="/pedidos-credores/novo"> Incluir
                                </v-btn>
                            </template>
                            <span>Adicionar</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Número do Pedido"
                                        v-model="dataList.filter.request_number" hide-details outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="CPF" v-model="dataList.filter.registration" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Origem" v-model="dataList.filter.origin" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Valor" v-model="dataList.filter.value" hide-details
                                        outlined></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnFilter" type="submit" color="primary" dark
                                                elevation="2">Filtrar
                                            </v-btn>
                                        </template>
                                        <span>Filtrar dados</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="4" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Procurar"
                                        v-model="dataList.filter.content" no-data-text="Nenhuma informação disponível" 
                                        hide-details outlined clearable @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title">Pedidos Importados
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum pedido foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.request_number`]="{ item }">
                                {{ item.request_number }}
                            </template>

                            <template v-slot:[`item.registration`]="{ item }">
                                {{ formatCpfCnpj(item.registration) }}
                            </template>

                            <template v-slot:[`item.origin`]="{ item }">
                                {{ item.origin }}
                            </template>

                            <template v-slot:[`item.value`]="{ item }">
                                R$ {{ item.value | currency }}
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-tooltip bottom v-if="!$check(user, ['creditorsrequests.update'])">
                                    <template #activator="{ on }">
                                        <v-icon icon v-on="on"
                                            :disabled="!$check(user, ['creditorsrequests.find'])"
                                            @click="viewItem(item)" size="large" v-if="!item.excluded_by" class="me-2">
                                            mdi-eye-outline
                                        </v-icon>
                                    </template>
                                    <span>Visualizar dados do pedido</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon icon v-on="on"
                                            :disabled="(!$check(user, ['creditorsrequests.update']))"
                                            @click="viewItem(item)" size="large" v-if="!item.excluded_by" class="me-2">
                                            mdi-pencil-outline
                                        </v-icon>
                                    </template>
                                    <span>Editar dados do pedido</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-icon
                                            :disabled="(!$check(user, ['creditorsrequests.delete']))"
                                            icon v-on="on" @click="deleteItem(item)" size="large" class="me-2">
                                            mdi-delete-outline
                                        </v-icon>
                                    </template>
                                    <span>Excluir pedido</span>
                                </v-tooltip>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import { cpf, cnpj } from 'cpf-cnpj-validator'
import creditorTypes from "@/common/data/creditor-types.data"

import object from "@/common/util/object"

import userTypes from "@/common/data/user-types.data";

Vue.use(VueLodash)

export default {
    name: "UserList",

    data: () => ({
        dataset: {
            userTypes: userTypes,
            clients: [],
            data: {},
            creditorTypes: creditorTypes
        },
        dataForm: {
            validForm: true,
        },
        dataList: {
            user: null,
            filter: {
                content: "",
            },
            headers: [
                { text: "Número do Pedido", value: "request_number" },
                { text: "CPF/CNPJ", value: "registration" },
                { text: "Origem", value: "origin" },
                { text: "Valor", value: "value" },
                { text: "Criado em", value: "created_at" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.load(true);
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "");
        },

        clearFilters() {
            Object.keys(this.dataList.filter).forEach(key => {
                this.dataList.filter[key] = "";
            });
            this.load();
        },

        clearNameSearch() {
            this.dataList.filter.content = "";
            this.load();
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        /*validateXLSXFile(file) {
            return file && file.name && file.name.endsWith('.xlsx');
        },*/

        getTypeName(typeId) {
            const type = this.dataset.creditorTypes.find(s => s.id === typeId);
            return type.name ? type.name : 'N/A';
        },

        truncateText(text, maxLength) {
            if (text.length > maxLength) {
                return text.slice(0, maxLength) + '...';
            }
            return text;
        },

        formatCpfCnpj(value) {
            return value.length == 14 ? cnpj.format(value) : cpf.format(value);
        },

        viewItem(item) {
            this.$router.push(`pedidos-credores/${item.id}`);
        },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v || v === 0));

            //console.log("Filtros a serem enviados para a API:", search);
            search = !object.isEmpty(search) ? search : null;
            this.dataList.loading = true;
            const limit = this.dataList.options.itemsPerPage;

            try {
                const result = await axios.get('/api/creditors-requests', {
                    params: { page: this.dataList.options.page, limit, ...search },
                });

                //console.log("Dados recebidos da API:", result.data);

                this.dataList.data = result.data.data.data;
                this.dataList.count = result.data.data.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000,
                });
            } finally {
                this.dataList.loading = false;
            }
        },



        async deleteItem(item) {
            const proceedAction = await this.$dialog.confirm({
                text: "Deseja efetuar a exclusão deste pedido?",
                title: "Excluir pedido",
                actions: {
                    false: "Cancelar",
                    true: "Excluir",
                },
            });

            if (!proceedAction) return;

            const id = item.id;
            //console.log("Excluindo o item com ID:", id);

            this.dataList.loading = true;

            try {
                const response = await axios.delete(`/api/creditors-requests/${id}`);

                this.$dialog.notify.info("Pedido excluído com sucesso!", {
                    position: "top-right",
                    timeout: 3000,
                });

                this.load();
            } catch (error) {
                console.error("Erro ao excluir o pedido:", error);
                this.$dialog.notify.error(this.$codes(error), {
                    position: "top-right",
                    timeout: 2000,
                });
            } finally {
                this.dataList.loading = false;
            }
        },


        /*async uploadFile() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja enviar a lista de pedidos?',
                title: 'Lista de pedidos',
                actions: {
                    false: 'Cancelar',
                    true: 'Enviar'
                }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;
            this.dataset.progress = 0;

            try {

                const payload = this.buildPayload()

                const response = await axios.post('/api/admin/creditor-requests/upload', payload, {
                    onUploadProgress: (event) => {
                        this.dataset.progress = Math.round((100 * event.loaded) / event.total);
                    }
                })

                this.dataset.errorData = response.data.content.errors

                if (this.dataset.errorData.length) {
                    this.$dialog.notify.error("Encontramos alguns erros na lista enviada, verifique-os abaixo!", { position: "top-right", timeout: 3000 });

                    return
                }

                this.$dialog.notify.info("Lista de pedidos enviada com sucesso, aguarde novas atualizações", { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },*/


    },
};
</script>

<style lang="scss">
.excluded-record {
    opacity: 0.6;
    pointer-events: none;
    color: #aaa;
}
</style>